import appConfig from '@/configs/app.config'
import { REDIRECT_URL_KEY } from '@/constants/app.constant'
import { Navigate, Outlet, useLocation } from 'react-router-dom'
import { useAuth } from '@/auth'

const { unAuthenticatedEntryPath } = appConfig

const ProtectedRoute = () => {
    const { authenticated } = useAuth()

    const { pathname, search } = useLocation()

    /**
     * Where to come back to after signing in — **including the query string**.
     *
     * Dropping the search was a quiet bug until something depended on it. The
     * desktop recorder opens `/settings/devices?code=ABCD2345` to have a device
     * approved, and that is exactly the link a person is least likely to be
     * signed in for: it is the first thing the app does after being installed.
     * Losing the code sent them to an empty form with no way to know what had
     * been lost, while the app sat polling for an approval that was never coming.
     *
     * Encoded, because the value is itself a query string: unencoded, its first
     * `&` would be read as the end of `redirectUrl`. `AuthProvider.redirect`
     * reads it back through `URLSearchParams.get`, which decodes.
     */
    const getPathName =
        pathname === '/'
            ? ''
            : `?${REDIRECT_URL_KEY}=${encodeURIComponent(pathname + search)}`

    if (!authenticated) {
        return (
            <Navigate
                replace
                to={`${unAuthenticatedEntryPath}${getPathName}`}
            />
        )
    }

    return <Outlet />
}

export default ProtectedRoute
